// MedienBreiten: 
// < 768 MOBILE
// 768 bis 1024 TABLET
// Alles darüber DESKTOP

import React, { Component } from 'react';
import './styles/App.css';
import {checkMedia} from './helpers.js'

import {BrowserRouter as Router} from 'react-router-dom'
import {Route, Switch, Redirect } from 'react-router-dom'
import Header from './Header'
import axios from 'axios'
import {dataSource} from './constants.js'
import About from './About'
import Auswahl from './Auswahl'
import Start from './Start'
import { animateScroll } from 'react-scroll'

import Loader from './Loader'
import Project from './Project'

class App extends Component {

  constructor(props) {
    super(props);
    this.state={
      media: checkMedia(),
      innerHeight: window.innerHeight,
      content:{
        there: false,
      },
      storedScrollPosition: 0,
    }

    this.handleResize = this.handleResize.bind(this)
    this.getContent = this.getContent.bind(this)

    this.setFilterSection = this.setFilterSection.bind(this)
    this.setFilterSelect = this.setFilterSelect.bind(this)
    this.storeScrollPosition = this.storeScrollPosition.bind(this)
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize ,false)
    this.getContent()
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize ,false)
  }

  render() {
    const {media, content, filter, innerHeight} = this.state
    const filterFunctions = {
      setFilterSection: this.setFilterSection,
      setFilterSelect: this.setFilterSelect,
    }
    return (
        <Router >
          <div 
            className={"App "+ media} 
            style={{minHeight:innerHeight}}
            >

            <Route
              path="/:type/:slug"
              exact 
              children={props=>{
              const {match} = props
              let isProjectView = (match !== null)

                  return(
                    <Header media={media} isProjectView={isProjectView}/> 
                  )

              }
            } /> 
            <Route render={({location})=>(
              <RouteChecker 
                storedScrollPosition={this.state.storedScrollPosition} 
                location={location}
              />
            )} />

          {content.there?
            <Switch location={this.props.location}>
                    <Route
                      path="/art"
                      exact
                      render={props=>{
                        return(
                            <Auswahl 
                              content={content} 
                              section='art' 
                              media={media} 
                              filter={filter} 
                              filterFunctions={filterFunctions}
                              storeScrollPosition={this.storeScrollPosition}
                            />
                          )
                        }
                      } />

                    <Route
                      path="/com"
                      exact 
                      render={props=>{
                        return(
                            <Auswahl 
                              content={content} 
                              section='com' 
                              media={media} 
                              filter={filter} 
                              filterFunctions={filterFunctions}
                              storeScrollPosition={this.storeScrollPosition}
                            />
                          )

                      }} />

                    <Route
                      path="/:type/:slug"
                      exact 
                      render={props=>{
                        const {match} = props
                        const project = content[match.params.type].find((p)=>{return p.slug === match.params.slug})
                        if(typeof project !== 'undefined'){
                          return(
                              <Project 
                                location={props.location} 
                                project={project} 
                                innerHeight={innerHeight} 
                                media={media} 
                              />
                            )
                        }else{
                          return(<Redirect to="/"/>)
                        }
                      }
                      } /> 


                    <Route
                      path="/about"
                      exact
                      render={props=>(
                          <About content={content} />
                      )} /> 


                    <Route
                      path="/"
                      exact
                      render={props=>(
                        <Start content={content}/>
                      )} />
                    <Redirect to="/"/>
                  </Switch>
          : null }
                <Loader in={!content.there} />
          </div>
        </Router>
    )
  }

  handleResize(){
    const { media, innerHeight } = this.state

    if(media !== checkMedia() || Math.abs(window.innerHeight - innerHeight) > 100 ){
      this.setState({
        media:checkMedia(), 
        innerHeight: window.innerHeight, 
      })
    }
  }

  getContent(){
    axios.all( [ axios.get(`${dataSource}/commissioned.json`) , axios.get(`${dataSource}/art.json`) , axios.get(`${dataSource}/about.json`) ])
    .then(
      axios.spread((com,art,about)=>{
      let artChoices = []

      art.data.data.forEach((p)=>{
        if( artChoices.indexOf(p.kategorie) === -1 ){
          artChoices.push(p.kategorie)
        }
      })


      let comChoices = []

      com.data.data.forEach((p)=>{
        if( comChoices.indexOf(p.kategorie) === -1 ){
          comChoices.push(p.kategorie)
        }
      })


        this.setState({
          content:{
            there: true,
            com: com.data.data,
            art: art.data.data,
            about: about.data.data,
          },
          filter:{
            choices: {
              art: artChoices,
              com: comChoices,
            },
            section:'',
            selected:[],
          }
        })
        
      })
    )
  }

  setFilterSection( section, newSelected ){
    let selected = []
    if ( newSelected !== undefined) {
      selected = [newSelected,]
    }
    this.setState((prevState) => {
      return {
        filter:{
          choices: prevState.filter.choices,
          section: section,
          selected: selected,
        } 
      }
    })
  }

  setFilterSelect(select){
    const {filter} = this.state
    let newSelected = []
    if(typeof select !== 'undefined'){
      const index = filter.selected.indexOf(select)
      newSelected = filter.selected
      if( index === -1){
        // Add
        newSelected.push(select)
      }else{
        // Remove
        newSelected.splice( index, 1 )
      }
    }
    this.setState((prevState) => {
      return {
        filter:{
          choices: prevState.filter.choices,
          section: prevState.filter.section,
          selected: newSelected,
        } 
      }
    })
  }

  storeScrollPosition(p){
    this.setState({
      storedScrollPosition: p,
    })
  }


}

export default App;

class RouteChecker extends React.Component{

  componentWillReceiveProps(nextProps) {
    const prevPath = this.props.location.pathname
    const nextPath = nextProps.location.pathname

    if(prevPath !== nextPath && prevPath.split('/')[1] === nextPath.split('/')[1] && nextPath.split('/').length === 2 && prevPath.split('/').length === 3){
      console.log('scroll', this.props.storedScrollPosition)
      animateScroll.scrollTo(this.props.storedScrollPosition,{duration:0})
    }else if(prevPath !== nextPath){
      animateScroll.scrollTo(0,{duration:0})

    }
  }
  render(){
    return null
  }
}



// WEBPACK FOOTER //
// ./src/App.js